/**
 * Utility functions for handling invite links
 */

/**
 * Generates a full invite URL from an invite code
 * @param {string} inviteCode - The invite code to generate a URL for
 * @returns {string} The full URL for the invite link
 */
export const generateInviteUrl = (inviteCode) => {
  if (!inviteCode) return '';
  
  // Use the current origin for the base URL
  const baseUrl = window.location.origin;
    
  return `${baseUrl}/group-invite/${inviteCode}`;
};
